import React, { useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';
import s from './SettingsBlock.module.css';
import sg from '../../../../styles/index.module.css';
import { updateInventoryRequest } from '../../../store/slices/boardSlice';

export function InventoryNumber({ value, parameterName, labelText, inventoryGuid, hasFullAccess }) {
    const [newValue, setNewValue] = useState(value || '');
    const dispatch = useDispatch();

    const setValue = useCallback(() => {
        const val = newValue.trim();
        dispatch(
            updateInventoryRequest({
                body: JSON.stringify({ [parameterName]: val }),
                inventoryGuid,
            })
        );
        setNewValue(val);
    }, [newValue, parameterName, inventoryGuid]);

    return (
        <div className={s.inventoryNumber}>
            <label>
                <span className={s.title}>{labelText}</span>
                {hasFullAccess && (
                    <input
                        data-id="inventory-number"
                        type="text"
                        className={sg.input}
                        maxLength="255"
                        value={newValue}
                        onFocus={(e) => {
                            e.target.select();
                        }}
                        onBlur={setValue}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                                e.currentTarget.blur();
                            }
                        }}
                        onChange={(e) => {
                            setNewValue(e.target.value);
                        }}
                    />
                )}
                {!hasFullAccess && <div className={s.valueText}>{value}</div>}
            </label>
        </div>
    );
}
